import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
export default {
  name: 'FieldSection',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor: function backgroundColor() {
      return this.payload.primary.background_color;
    },
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    titleColor: function titleColor() {
      return this.payload.primary.title_color;
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    subtitleColor: function subtitleColor() {
      return this.payload.primary.subtitle_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph || [];
    },
    paragraphColor: function paragraphColor() {
      return this.payload.primary.paragraph_color;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    spacing: function spacing() {
      return this.payload.primary.spacing;
    }
  }
};